const StepId = {
    APPLICANT_INFO: "applicantInfo",
    JOINT_APPLICANT_INFO: "jointApplicantInfo",
    TERMS: "termsAndConditions",
    ACCEPT_OFFER: "acceptOffer",
    PAYMENT_OPTIONS: "paymentOptions",
    COMPLETE: "complete",
    BEGIN_STANDARD_APPLICATION: "beginStandardApplication"
}

export default StepId
